import { sdkRequest } from '@eventbrite/http';
import { VenueDTO } from '../types';

export const getVenue = (venueId: string): Promise<VenueDTO> => {
    const options = {
        method: 'GET',
    };

    return sdkRequest(`/api/v3/venues/${venueId}/`, options);
};
